import { produce } from "immer";
import { Store } from "reducers/rootReducer";

/* Constants */
const SHRINK_NAV_BAR = "app/navBarStatus/SHRINK_NAV_BAR";

type ValueOf<T> = T[keyof T];

type NavBarStatusState = {
  fullSize: boolean;
};

type ShrinkNavBarAction = {
  type: typeof SHRINK_NAV_BAR;
  payload: boolean;
};

/* Reducer */

const initialRegisterState: NavBarStatusState = {
  fullSize: false,
};

export const shrinkNavBarReducer = (
  state: NavBarStatusState = initialRegisterState,
  action: ShrinkNavBarAction
): NavBarStatusState =>
  produce(state, draft => {
    switch (action.type) {
      case SHRINK_NAV_BAR:
        draft.fullSize = action.payload;
        break;
    }
  });

/* Action Creators */

export const setIsNavBarShrunk = (payload: boolean): ShrinkNavBarAction => ({
  type: SHRINK_NAV_BAR,
  payload,
});

/* Selectors */
export const selectIsNavBarShrunk = (state: Store) =>
  state.shrinkNavBar.fullSize;
